import React, {
    useEffect
} from "react";

import {
    useDispatch,
    useSelector
} from "react-redux";

import {
    fetchTenantUserById
} from "../store/reducers/tenantUserSlice";

import {
    jwtDecode
} from "jwt-decode";


const AuthInitializer = ({
                             children
                         }) => {

    const dispatch =
        useDispatch();

    const isAuthenticated =
        useSelector(
            state =>
                state.auth?.isAuthenticated
        );

    const tenantUser =
        useSelector(
            state =>
                state.tenantUser?.tenantUser
        );


    useEffect(() => {

        if (!isAuthenticated) {
            return;
        }

        /*
        |--------------------------------------------------------------------------
        | Already loaded
        |--------------------------------------------------------------------------
        */

        if (tenantUser) {
            return;
        }


        /*
        |--------------------------------------------------------------------------
        | Get JWT
        |--------------------------------------------------------------------------
        */

        const token =
            localStorage.getItem("token");

        if (!token) {
            return;
        }


        try {

            const decoded =
                jwtDecode(token);

            const userId =
                decoded?.user_id;


            if (!userId) {

                console.error(
                    "user_id absent du JWT"
                );

                return;
            }


            /*
            |--------------------------------------------------------------------------
            | Fetch TenantUser
            |--------------------------------------------------------------------------
            */

            dispatch(
                fetchTenantUserById(
                    userId
                )
            );

        } catch (error) {

            console.error(
                "Impossible de décoder le JWT",
                error
            );
        }

    }, [
        isAuthenticated,
        tenantUser,
        dispatch
    ]);


    return children;
};


export default AuthInitializer;